import util from '@assets/js/util';
import routes from '../../router/modules';
import router from '../../router';
import ajax from '../../assets/js/interceptor';

export default {
  state: {
    canLoginAppList: [],
    breadCrumbList: [], // 导航面包屑数据
    tagNavList: [],
    homeRoute: {},
    footerButtonArr: [], // footer按钮
    filterStatus: false // 筛选条件展开/收起状态
  },
  mutations: {
    setBreadCrumb (state, route) {
      state.breadCrumbList = util.getBreadCrumbList(route, state.homeRoute);
    },
    setHomeRoute (state, routes) {
      state.homeRoute = util.getHomeRoute(routes);
    },
    addTag (state, { route, type = 'unshift' }) {
      const router = util.getRouteTitleHandled(route);
      if (!util.routeHasExist(state.tagNavList, router)) {
        if (type === 'push') state.tagNavList.push(router);
        else {
          if (router.name === 'home') state.tagNavList.unshift(router);
          else state.tagNavList.splice(1, 0, router);
        }
        util.setTagNavListInLocalstorage([{ name: 'home', params: {}, query: {}, meta: { title: '欢迎页', icon: 'md-home', hideInMenu: true } }]);
      }
    },
    closeTag (state, route) {
      const tag = state.tagNavList.filter(item => util.routeEqual(item, route));
      route = tag[0] ? tag[0] : null;
      if (!route) return;
      const nextRoute = util.getNextRoute(state.tagNavList, route);
      state.tagNavList = state.tagNavList.filter(item => {
        return !util.routeEqual(item, route);
      });
      router.push(nextRoute);
    },
    setTagNavList (state, list) {
      let tagList = [];
      if (list) {
        tagList = [...list];
      } else tagList = util.getTagNavListFromLocalstorage() || [];
      if (tagList[0] && tagList[0].name !== 'home') tagList.shift();
      const homeTagIndex = tagList.findIndex(item => item.name === 'home');
      if (homeTagIndex > 0) {
        const homeTag = tagList.splice(homeTagIndex, 1)[0];
        tagList.unshift(homeTag);
      }
      state.tagNavList = tagList;
      util.setTagNavListInLocalstorage([{ name: 'home', params: {}, query: {}, meta: { title: '欢迎页', icon: 'md-home', hideInMenu: true } }]);
    },
    // 修改筛选条件展开/收起状态
    changeFilterStatus (state) {
      state.filterStatus = !state.filterStatus;
    },
    // 更新footerButtonArr
    changeFooterButtonArr (state, arr) {
      state.footerButtonArr = arr;
    },

    changeAddressList (state, arr) {
      state.addressList = arr;
    },
    changeSysList (state, list) {
      state.canLoginAppList = list;
    }
  },
  actions: {
    getCanLoginAppList ({ commit, dispatch, state }, payload) {
      return new Promise(resolve => {
        ajax.get('/v1/userInfo/canLoginApps').then(res => {
          const { data, code } = res.data;
          if (code == 200) {
            const canLoginAppList = data.map(i => {
              const { appName = '', ...rest } = i;
              return { label: i.appName, ...rest };
            });
            commit('changeSysList', canLoginAppList);
            resolve({ list: data, msg: 'success' });
          } else {
            resolve({ list: '', msg: data.msg });
          }
        });
      });
    }
  },
  getters: {
    menuList: (state, getters, rootState) => util.getMenuByRouter(rootState.permission.promiseMenu, rootState.user.access)
  }
};
